"use client";

import dynamic from 'next/dynamic';
import React from 'react';

// Composant de loading pour le Header
const HeaderLoading = () => (
  <header className="bg-white shadow-md p-4 sticky top-0 z-50">
    <div className="max-w-4xl mx-auto flex items-center justify-center">
      <div className="relative flex items-center">
        <div className="flex items-center">
          <div className="relative h-20 w-24 mr-3 bg-gray-200 animate-pulse rounded"></div>
          <div className="ml-3">
            <div className="h-8 w-32 bg-gray-200 animate-pulse rounded mb-2"></div>
            <div className="h-4 w-48 bg-gray-200 animate-pulse rounded"></div>
          </div>
        </div>
      </div>
    </div>
  </header>
);

// Importation dynamique du Header avec rendu côté client uniquement
const Header = dynamic(() => import('./Header'), {
  ssr: false,
  loading: () => <HeaderLoading />
});

const HeaderWrapper: React.FC = () => {
  return <Header />;
};

export default HeaderWrapper; 